<template>
  <div class="investig">
    <!-- 案件调查信息 -->
    <div class="section-block">
      <div class="section-title">案件调查信息</div>
      <el-form ref="formRef" :model="form" :rules="auxRules" label-width="140px" class="section-form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="案件分类" prop="caseTypeCode">
              <el-select v-model="form.caseTypeCode" placeholder="请选择案件分类" clearable style="width: 100%;">
                <el-option
                    v-for="item in caseClassificationOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="承办人" prop="undertakerName">
              <el-input v-model="form.undertakerName" placeholder="请输入承办人" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参保情况" prop="insuredConditionCode">
              <el-select v-model="form.insuredConditionCode" placeholder="请选择参保情况" clearable
                         style="width: 100%;" @change="handleInsuredConditionChange">
                <el-option
                    v-for="item in insuranceStatusOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="与关联单位关系" prop="unitRelationCode">
              <el-select v-model="form.unitRelationCode" placeholder="请选择与关联单位关系" clearable
                         style="width: 100%;" @change="handleUnitRelationChange">
                <el-option
                    v-for="item in relationWithUnitOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="showAssociatedUnit" :span="8">
            <el-form-item label="关联单位">
              <el-input v-model="form.unitName" placeholder="请输入关联单位" clearable/>
            </el-form-item>
          </el-col>
          <el-col v-if="showProjectName" :span="8">
            <el-form-item label="项目名称">
              <el-input v-model="form.projectName" placeholder="请输入项目名称" clearable/>
            </el-form-item>
          </el-col>
          <!--                    <el-col :span="8">-->
          <!--                        <el-form-item label="认定操作日期">-->
          <!--                            <el-date-picker-->
          <!--                                v-model="form.certificationDate"-->
          <!--                                type="date"-->
          <!--                                placeholder="请选择日期"-->
          <!--                                value-format="YYYY-MM-DD"-->
          <!--                                style="width: 100%;"-->
          <!--                            />-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :span="8">
            <el-form-item label="中止原因">
              <el-select v-model="form.suspendCauseCode" placeholder="请选择中止原因" clearable style="width: 100%;">
                <el-option
                    v-for="item in effectiveSuspensionReasonOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="showSuspensionDates" :span="8">
            <el-form-item label="中止日期">
              <el-date-picker
                  v-model="form.suspendDate"
                  type="date"
                  placeholder="请选择中止日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :picker-options="{disabledDate: disabledStartDate}"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="showSuspensionDates" :span="8">
            <el-form-item label="恢复日期">
              <el-date-picker
                  v-model="form.suspendRecoverDate"
                  type="date"
                  placeholder="请选择恢复日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  :picker-options="{disabledDate: disabledEndDate}"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 劳动关系与参保情况说明 -->
    <div class="section-block">
      <div class="section-title">劳动关系与参保情况说明</div>
      <el-form :model="form" label-width="140px" class="section-form">
        <el-form-item label="劳动关系说明">
          <el-input
              v-model="form.laborRelationExplain"
              type="textarea"
              :rows="4"
              placeholder="自(待补充)年(待补充)月(待补充)日起至今，张三与上海某科技有限公司建立劳动关系，从事(待补充)工作。双方签订的劳动合同可以证明。"
              resize="vertical"
          />
        </el-form-item>
        <el-form-item label="参保情况说明">
          <el-input
              v-model="form.insuranceParticipationExplain"
              type="textarea"
              :rows="4"
              placeholder="上海某科技有限公司正常为张三缴纳工伤保险。"
              resize="vertical"
          />
        </el-form-item>
        <!-- 调查辅助信息 -->
        <div class="section-block">
          <div class="section-title">调查辅助信息</div>
<!--          <el-form ref="auxFormRef" :model="form" :rules="auxRules" label-width="200px" class="section-form">-->
            <el-form-item label="是否属于安全生产事故" prop="isWorkSafetyAccident">
              <el-select v-model="form.isWorkSafetyAccident" placeholder="请选择是否属于安全生产事故" clearable style="width: 100%;">
                <el-option
                    v-for="item in yesNoOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
            <!--        <el-form-item label="调查时间" prop="surveyDate" required>-->
            <!--          <el-date-picker-->
            <!--              v-model="form.surveyDate"-->
            <!--              type="datetime"-->
            <!--              placeholder="请选择时间"-->
            <!--              value-format="YYYY-MM-DD HH:mm:ss"-->
            <!--              style="width: 100%;"-->
            <!--          />-->
            <!--        </el-form-item>-->
            <el-form-item label="事故前3周医保查询情况">
              <el-input
                  v-model="form.medicalInsuranceSituation"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入医保查询情况"
                  resize="vertical"
              />
            </el-form-item>
            <el-form-item label="事故前3周就诊记录">
              <el-input
                  v-model="form.medicalRecord"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入就诊记录"
                  resize="vertical"
              />
            </el-form-item>
<!--          </el-form>-->
        </div>
      </el-form>
    </div>



    <!-- 操作按钮 -->
    <div class="section-block section-actions" v-if="form.status!=2">
      <el-button type="primary" plain @click="handleSave(1)">保存调查信息</el-button>
      <el-button type="primary" @click="handleSave(2)">结束调查</el-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {getListByDictType} from '@/api/sys/dictData'
import {addSurveyInfo,getSurveyInfo} from '@/api/recognition/survey'

const emptyForm = () => ({
  caseTypeCode: '',
  undertakerName: '',
  insuredConditionCode: '',
  unitRelationCode: '',
  unitName: '',
  projectName: '',
  suspendDate: '',
  suspendRecoverDate: '',
  certificationDate: '',
  suspendCauseCode: '',
  laborRelationExplain: '',
  insuranceParticipationExplain: '',
  surveyDate: '',
  medicalInsuranceSituation: '',
  medicalRecord: '',
  status:1,
  isWorkSafetyAccident:''
})

export default {
  name: 'Investig',
  props: {
    /** 已保存的调查信息，用于回显；父组件传入后表单会同步 */
    savedData: {
      type: Object,
      default: () => ({})
    },
    step1info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    let that=this;
    return {
      form: emptyForm(),
      caseClassificationOptions: [],
      insuranceStatusOptions: [],
      relationWithUnitOptions: [],
      suspensionReasonOptions: [],
      yesNoOptions:[],
      auxRules: {
        surveyDate: [
          {required: true, message: '请输入调查时间', trigger: 'blur'}
        ],
        undertakerName: [
          {required: true, message: '请输入承办人', trigger: 'blur'}
        ],
        caseTypeCode:[
          {required: true, message: '请选择案件分类', trigger: 'blur'}
        ],
        insuredConditionCode:[
         {required: true, message: '请选择参保情况', trigger: 'blur'}
        ],
        unitRelationCode:[
        {required: true, message: '请选择与关联单位关系', trigger: 'blur'}
        ]
      },
      disabledStartDate:(time) => {
        return time.getTime() > new Date(that.form.suspendRecoverDate).getTime()
      },
      disabledEndDate:(time) => {
        return time.getTime() < new Date(that.form.suspendDate).getTime()
      },
    }
  },
  computed: {
    ...mapGetters(['name']),
    showAssociatedUnit() {
      const v = String(this.form.unitRelationCode ?? '')
      return ['2', '4', '5'].includes(v)
    },
    showProjectName() {
      return String(this.form.unitRelationCode ?? '') === '3'
    },
    effectiveSuspensionReasonOptions() {
      const list = this.suspensionReasonOptions || []
      const hasNone = list.some((item) => (item.dictLabel || '').trim() === '无')
      if (hasNone) return list
      return [{dictLabel: '无', dictValue: '0'}, ...list]
    },
    isSuspensionReasonNone() {
      if (this.form.suspendCauseCode === '' || this.form.suspendCauseCode == null) return true
      const opt = (this.suspensionReasonOptions || []).find(
          (item) => String(item.dictValue) === String(this.form.suspendCauseCode)
      )
      if (opt) return (opt.dictLabel || '').trim() === '无'
      return String(this.form.suspendCauseCode) === '0'
    },
    showSuspensionDates() {
      if (this.form.suspendCauseCode === '' && this.form.suspendCauseCode !== 0) return false
      return !this.isSuspensionReasonNone
    }
  },
  watch: {
    // savedData: {
    //   deep: true,
    //   handler(val) {
    //     if (val && typeof val === 'object' && Object.keys(val).length) {
    //       this.form = {...emptyForm(), ...val}
    //     }
    //   }
    // }
  },
  created() {
    this.loadDictData()
    // this.syncFromSaved();
    this.getDetail()
    this.applyDefaultUndertakerIfEmpty()
  },
  methods: {
    /** 承办人未填写时默认当前登录用户（与受理弹窗一致） */
    applyDefaultUndertakerIfEmpty() {
      if (this.form.undertakerName) return
      const state = this.$store.state.user || {}
      console.log( state,'this.name')
      this.form.undertakerName = state.name || ''
    },
    /** 将字典 remark 中的 ${name}/${unit} 替换为伤者姓名、用人单位名称 */
    fillRemarkTemplate(remark) {
      if (!remark) return ''
      const name = this.step1info?.woundedName || ''
      const unit = this.step1info?.unitName || ''
      return String(remark)
          .replace(/\$\{name\}/g, name)
          .replace(/\$\{unit\}/g, unit)
    },
    /** 参保情况变更 → 渲染参保情况说明 */
    handleInsuredConditionChange(val) {
      if (val === '' || val == null) {
        this.form.insuranceParticipationExplain = ''
        return
      }
      const opt = (this.insuranceStatusOptions || []).find(
          (item) => String(item.dictValue) === String(val)
      )
      this.form.insuranceParticipationExplain = this.fillRemarkTemplate(opt?.remark)
    },
    /** 与关联单位关系变更 → 渲染劳动关系说明 */
    handleUnitRelationChange(val) {
      if (val === '' || val == null) {
        this.form.laborRelationExplain = ''
        return
      }
      const opt = (this.relationWithUnitOptions || []).find(
          (item) => String(item.dictValue) === String(val)
      )
      this.form.laborRelationExplain = this.fillRemarkTemplate(opt?.remark)
    },

    syncFromSaved() {
      if (this.savedData && typeof this.savedData === 'object' && Object.keys(this.savedData).length) {
        this.form = {...emptyForm(), ...this.savedData}
      }
    },
    async loadDictData() {
      const dictTypes = [
        {key: 'caseClassificationOptions', type: 'industrial_injury_case_classification'},
        {key: 'insuranceStatusOptions', type: 'industrial_injury_insurance_status'},
        {key: 'relationWithUnitOptions', type: 'industrial_injury_relation_with_unit'},
        {key: 'suspensionReasonOptions', type: 'industrial_injury_suspension_reason'},
        {key: 'yesNoOptions', type: 'sys_yes_no'}
      ]
      for (const {key, type} of dictTypes) {
        try {
          const res = await getListByDictType(type)
          if (res && res.code === 200 && res.data) {
            this[key] = res.data
            if (key === 'suspensionReasonOptions') {
              const noneOpt = (res.data || []).find(
                  (item) => (item.dictLabel || '').trim() === '无'
              )
              if (!this.savedData || !this.savedData.suspendCauseCode) {
                this.form.suspendCauseCode = noneOpt ? noneOpt.dictValue : '0'
              }
            }
          }
        } catch (e) {
          console.warn(`字典 ${type} 加载失败`, e)
        }
      }
    },
    handleSave(state) {
      if (state == 1) {
        this.form.status = state
        this.submit()
      } else {
        this.$refs.formRef.validate(valid=>{
          if(valid){
            let type=(this.step1info.woundedBlack || this.step1info.unitBlack)?2:1
            this.$confirm((type==1?'确定要结束调查吗？':'该主体处于黑名单状态，请确认是否继续办理/是否存在特殊审批流程？'), '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.form.status = state
              this.handleComplete()
            })
          }
        })
      }
    },
    handleComplete() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit() {
      let caseId = this.$route.query.id
      if (!caseId) return
      this.form.caseId = caseId
      this.form.caseTypeName=this.selectDictLabel(this.caseClassificationOptions,this.form.caseTypeCode);
      this.form.insuredConditionName=this.selectDictLabel(this.insuranceStatusOptions,this.form.insuredConditionCode);
      this.form.unitRelationName=this.selectDictLabel(this.relationWithUnitOptions,this.form.unitRelationCode);
      this.form.suspendCauseName=this.selectDictLabel(this.effectiveSuspensionReasonOptions,this.form.suspendCauseCode);
      addSurveyInfo(this.form).then(res => {
        if (res && res?.code === 200) {
          this.$message.success('提交成功')
        }
      })
    },
    getDetail(){
      let caseId = this.$route.query.id
      if (!caseId) return
      getSurveyInfo({caseId}).then(res => {
        if (res && res?.code === 200) {
          for (const resKey in emptyForm()) {
            this.form[resKey] = res.data[resKey] || ''
          }
          this.form.isWorkSafetyAccident=String(this.form.isWorkSafetyAccident) ||''
          this.applyDefaultUndertakerIfEmpty()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.investig {
  width: 100%;
  height: 100%;
}

.section-block {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding-left: 11px;
  margin-bottom: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: var(--vt-c-blue);
  }
}

.section-form {
  :deep(.el-form-item__label) {
    color: #606266;
    font-weight: 400;
  }
}

.section-actions {
  padding-top: 8px;
  padding-bottom: 24px;

  .el-button {
    margin-right: 12px;
  }
}
</style>
